import Project from '../components/Project'

function Home({ lang }) {
      return (
        <main className="page-container bg-custom">
          <Project lang={lang} />
        </main>
      );
    }
    
    export default Home;